<template>
    <div class="container">
        <div class="columns is-multiline">
            <div class="column is-12">
                <a href="/dashboard/leads/">Leads</a> &raquo; 
                <a :href="'/dashboard/leads/' + lead.id">{{ lead.contact_person }}</a> &raquo; 
                Edit

                <h1 class="title">Edit {{ lead.contact_person }}</h1>
            </div>

            <div class="column is-12">
                <form @submit.prevent="submitForm">
                     <div class="field">
                        <label>Contact person</label>
                        <div class="control">
                            <input type="text" class="input" v-model="lead.contact_person">
                        </div>
                    </div>
                    <div class="field">
                        <label>Job/position</label>
                        <div class="control">
                            <input type="text" class="input" v-model="lead.job">
                        </div>
                    </div>
                    <div class="field">
                        <label>Company</label>
                        <div class="control">
                            <input type="text" class="input" v-model="lead.company">
                        </div>
                    </div>


                    

                    <div class="field">
                        <label>Status</label>
                        <div class="control">
                            <div class="select">
                                <select v-model="lead.status">
                                    <option value="new">New</option>
                                    <option value="contacted">Contacted</option>
                                    <option value="inprogress">In progress</option>
                                    <option value="lost">Lost</option>
                                    <option value="won">Won</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="field">
                        <label>Priority</label>
                        <div class="control">
                            <div class="select">
                                <select v-model="lead.priority">
                                    <option value="low">Low</option>
                                    <option value="medium">Medium</option>
                                    <option value="high">High</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!--
                    <div class="field">
                        <label>Assigned to</label>
                        <div class="control">
                            <div class="select">
                                <select v-model="lead.assigned_to">
                                    <option value="" selected>Select member</option>
                                    <option
                                        v-for="member in team.members"
                                        v-bind:key="member.id"
                                        v-bind:value="member.id"
                                    >
                                        {{ member.username }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    -->
                    <div class="field">
                        <label>Brief:</label>
                        <div class="control">
                            <textarea rows="4" class="textarea" v-model="lead.snippet"></textarea>
                        </div>
                    </div>

                    <div class="field">
                        <label>Notes:</label>
                        <div class="control">
                            <textarea rows="12" class="textarea" v-model="lead.info"></textarea>
                        </div>
                    </div>

                    <div class="field">
                        <div class="control">
                            <button class="button is-success">Update</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    import { toast } from 'bulma-toast'

    export default {
        name: 'EditLead',
        data() {
            return {
                lead: {},
                team: {
                    members: []
                }
            }
        },
        mounted() {
            this.getLead()
            // this.getTeam() // for assigned_to
        },
        methods: {
            async getLead() {
                this.$store.commit('setIsLoading', true)

                const leadID = this.$route.params.id

                axios
                    .get(`/lms/leads/${leadID}/`)
                    .then(response => {
                        this.lead = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })

                this.$store.commit('setIsLoading', false)
            },
            async submitForm() {
                this.$store.commit('setIsLoading', true)

                const leadID = this.$route.params.id

                axios
                    .patch(`/lms/leads/${leadID}/`, this.lead)
                    .then(response => {
                        toast({
                            message: 'The lead was updated',
                            type: 'is-success',
                            dismissible: true,
                            pauseOnHover: true,
                            duration: 2000,
                            position: 'bottom-right',
                        })

                        this.$router.push(`/dashboard/leads/${leadID}`)
                    })
                    .catch(error => {
                        console.log(error)
                    })

                this.$store.commit('setIsLoading', false)
            },
            /* // for assigned_to
            async getTeam() {
                this.$store.commit('setIsLoading', true)

                await axios
                    .get('/lms/teams/get_my_team/')
                    .then(response => {
                        this.team = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
                
                this.$store.commit('setIsLoading', false)
            }
            */
        }
    }
</script>